export default __webpack_public_path__ + "static/media/logo_grabit.89f6d8b1.png";